import React from 'react'
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from '@material-ui/core'

export const ConfirmationDialog = ({
  open,
  loading,
  handleConfirmation,
  onCancel,
  title,
  message,
  entityIdentifier,
  optionalMessage,
  secondEntity,
  thirdMessage,
  thirdEntity,
  startIcon
}) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      backdropClick={loading}
      fullWidth
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography>
          {message}
          {entityIdentifier && (
            <Typography color='primary' component='span'>
              &nbsp;{entityIdentifier}&nbsp;
            </Typography>
          )}
          {optionalMessage}
          {secondEntity && (
            <Typography color='primary' component='span'>
              &nbsp;{secondEntity}&nbsp;
            </Typography>
          )}
          {thirdMessage}
          {thirdEntity && (
            <Typography color='primary' component='span'>
              &nbsp;{thirdEntity}
            </Typography>
          )}
        </Typography>
        <Typography>¿Desea continuar?</Typography>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onCancel}
          disabled={loading}
          color='primary'
          autoFocus={false}>
          No
        </Button>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Button
            onClick={handleConfirmation}
            disabled={loading}
            color='primary'
            variant='contained'
            startIcon={startIcon}
            autoFocus={false}>
            {loading ? <CircularProgress size={24} color='secondary' /> : 'Si'}
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  )
}
